import { OrderModel } from "../models/order";

export const findPhoneFromOrder = (data: OrderModel): string => {
  if (data?.address?.phone) {
    return data?.address?.phone;
  } else if (data?.customer?.phone) {
    return data?.customer?.phone;
  } else {
    return "";
  }
};
